import { Search } from 'lucide-react';

export type Filter = 'working' | 'all' | 'dead';

interface Props {
  query: string;
  onQueryChange(value: string): void;
  filter: Filter;
  onFilterChange(value: Filter): void;
  counts: Record<Filter, number>;
}

const FILTERS: Filter[] = ['working', 'all', 'dead'];
const LABELS: Record<Filter, string> = { working: 'Working', all: 'All', dead: 'Dead' };

export function Controls({ query, onQueryChange, filter, onFilterChange, counts }: Props) {
  return (
    <div className="controls">
      <label className="search">
        <span className="visually-hidden">Search codes and rewards</span>
        <Search size={15} />
        <input
          type="search"
          value={query}
          placeholder="Search a code or reward…"
          onChange={(event) => onQueryChange(event.target.value)}
          autoComplete="off"
          spellCheck={false}
        />
      </label>

      <div className="chips" role="group" aria-label="Filter codes">
        {FILTERS.map((id) => (
          <button
            key={id}
            type="button"
            className="chip"
            aria-pressed={filter === id}
            onClick={() => onFilterChange(id)}
          >
            {LABELS[id]} {counts[id]}
          </button>
        ))}
      </div>
    </div>
  );
}
